import { render, staticRenderFns } from "./Division.vue?vue&type=template&id=448fccea&scoped=true&"
import script from "./Division.vue?vue&type=script&lang=js&"
export * from "./Division.vue?vue&type=script&lang=js&"
import style0 from "./Division.vue?vue&type=style&index=0&id=448fccea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448fccea",
  null
  
)

export default component.exports